import { createTextVNode as _createTextVNode2, createVNode as _createVNode2 } from "vue";
import "core-js/modules/es.symbol.description.js";
import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-365ddbc4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "buttons"
};
const _hoisted_2 = {
  class: "saas-container"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title fadeInUp",
  wait: "200"
}, "产品功能特点", -1));
const _hoisted_4 = {
  class: "pic"
};
const _hoisted_5 = ["data"];
const _hoisted_6 = {
  class: "context"
};
const _hoisted_7 = {
  class: "title"
};
import { reactive, onMounted } from 'vue';
import { isMobile, observe } from '@/utils';
import { getUrllink } from '@/api';
import bannerBar from '@/components/banner';
import Scene from '@/components/scene';
import GetForm from '@/components/form';
export default {
  __name: 'index',
  setup(__props) {
    const basePath = window.appConfig.VUE_APP_PATH;
    const specialty = reactive([{
      ltitle: '合同快速起草，发起简单快捷',
      imgPosition: 'left',
      imgSrc: require('./img/pic1.svg'),
      description: () => _createVNode2("p", null, [_createTextVNode2("\u652F\u6301\u4F7F\u7528\u8349\u7A3F\u6587\u4EF6\u3001\u672C\u5730\u6587\u4EF6\u548C\u4F01\u4E1A\u81EA\u5B9A\u4E49\u6A21\u677F\u7B49\u591A\u79CD\u8D77\u8349\u65B9\u5F0F\uFF1B"), _createVNode2("br", null, null), _createTextVNode2("\u7CFB\u7EDF\u667A\u80FD\u8F6C\u6362\u6587\u4EF6\u683C\u5F0F\uFF0C\u7701\u65F6\u7701\u529B\uFF1B"), _createVNode2("br", null, null), _createTextVNode2("\u81EA\u52A8\u521B\u5EFA\u8054\u7CFB\u4EBA\uFF0C\u65B9\u4FBF\u5FEB\u901F\u6DFB\u52A0\u3002")])
    }, {
      ltitle: '合同智能审批，把控内部风险',
      imgPosition: 'right',
      imgSrc: require('./img/pic2.svg'),
      description: () => _createVNode2("p", null, [_createTextVNode2("\u652F\u6301\u4F01\u4E1A\u81EA\u5B9A\u4E49\u5BA1\u6279\u8282\u70B9\uFF0C\u4F01\u4E1A\u5185\u90E8\u5BA1\u6279\u901A\u8FC7\u540E\u624D\u5141\u8BB8\u7B7E\u7F72\uFF0C\u4E0D\u6539\u53D8\u4F01\u4E1A\u73B0\u884C\u6D41\u7A0B\uFF0C\u964D\u4F4E\u5916\u90E8\u6587\u4EF6\u7B7E\u7F72\u98CE\u9669\u3002")])
    }, {
      ltitle: '注册即用，签署方无需注册也能签',
      imgPosition: 'left',
      imgSrc: require('./img/pic3.svg'),
      description: () => _createVNode2("p", null, [_createTextVNode2("\u901A\u7528SaaS\u4E91\u7AEF\u670D\u52A1\uFF0C\u5373\u4E70\u5373\u7528\uFF1B"), _createVNode2("br", null, null), _createTextVNode2("\u5E73\u53F0\u7B7E\u7F72\u65B9\u4E0D\u9700\u8981\u6CE8\u518C\uFF0C\u53EF\u901A\u8FC7\u91CD\u5E86\u5E02\u653F\u5E9CAPP-\u8FDC\u7A0B\u7B7E\u7F72\u3002")])
    }, {
      ltitle: '多样化电子签署，满足不同场景需求',
      imgPosition: 'right',
      imgSrc: require('./img/pic4.svg'),
      description: () => _createVNode2("p", null, [_createTextVNode2("\u6307\u5B9A\u4F4D\u7F6E\u7B7E\u7F72\u3001\u81EA\u7531\u7B7E\u7F72\uFF1B"), _createVNode2("br", null, null), _createTextVNode2("\u652F\u6301\u591A\u6587\u4EF6\u4E00\u952E\u6279\u91CF\u7B7E\u7F72\uFF1B"), _createVNode2("br", null, null), _createTextVNode2("\u91C7\u7528\u751F\u7269\u8BC6\u522B\u6280\u672F\u786E\u8BA4\u7B7E\u7F72\u4EBA\u8EAB\u4EFD\u548C\u7B7E\u7F72\u610F\u613F\uFF1B"), _createVNode2("br", null, null), _createTextVNode2("\u652F\u6301\u4E34\u65F6\u8FFD\u52A0\u7B7E\u7F72\u4EBA\u3001\u6DFB\u52A0\u6284\u9001\u4EBA\u7B49\u7B7E\u7F72\u8981\u6C42\u3002")])
    }, {
      ltitle: '有微信，就能完成合同全流程管理',
      imgPosition: 'left',
      imgSrc: require('./img/pic5.svg'),
      description: () => _createVNode2("p", null, [_createTextVNode2("\u652F\u6301\u901A\u8FC7\u5FAE\u4FE1\u5C0F\u7A0B\u5E8F\u5B8C\u6210\u5408\u540C\u7684\u8D77\u8349\u3001\u53D1\u8D77\u3001\u5BA1\u6279\u3001\u7B7E\u7F72\u3001\u8FDB\u5EA6\u8DDF\u8E2A\u7BA1\u7406\u3002")])
    }, {
      ltitle: '权威、安全、可靠，助你签署无忧',
      imgPosition: 'right',
      imgSrc: require('./img/pic6.svg'),
      description: () => _createVNode2("p", null, [_createTextVNode2("\u5E73\u53F0\u7B26\u5408\u56FD\u5BB6\u4FE1\u606F\u5B89\u5168\u7B49\u7EA7\u4FDD\u62A4\u4E09\u7EA7\u8BA4\u8BC1\u8981\u6C42\uFF1B"), _createVNode2("br", null, null), _createTextVNode2("\u652F\u6301\u91CD\u5E86\u5E02\u653F\u5E9CAPP\u516C\u5F00\u67E5\u9A8C \uFF1B"), _createVNode2("br", null, null), _createTextVNode2("\u51C6\u786E\u8BC6\u522B\u7535\u5B50\u5370\u7AE0\u7684\u771F\u4F2A\uFF1B"), _createVNode2("br", null, null), _createTextVNode2("\u5168\u8FC7\u7A0B\u533A\u5757\u94FE\u94FE\u5F0F\u5B58\u8BC1\uFF0C\u6D41\u7A0B\u53EF\u8FFD\u6EAF\uFF0C\u652F\u6301\u53F8\u6CD5\u9274\u5B9A\u548C\u5FEB\u901F\u51FA\u8BC1\u3002")])
    }]);
    onMounted(() => {
      setTimeout(() => {
        observe(['.fadeInDown', '.fadeInUp', '.fadeInLeft', '.fadeInRight']);
      }, 200);
    });
    const goPage = async url => {
      if (!isMobile()) {
        return window.open(window.appConfig[url], '_blank');
      }
      const link = await getUrllink();
      location.href = link;
    };
    return (_ctx, _cache) => {
      const _directive_track = _resolveDirective("track");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_unref(bannerBar), {
        class: "saas-banner",
        head: "亲笔签电子合同",
        desc: "国际领先的生物笔迹电子合同文书签署存证平台",
        adCode: 1001
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_withDirectives((_openBlock(), _createElementBlock("div", {
          class: "link-button",
          onClick: _cache[0] || (_cache[0] = $event => goPage('loginUrl'))
        }, [_createTextVNode(" 立即体验 ")])), [[_directive_track, {
          button_name: '立即体验',
          click_info: 'banner',
          event_source: 'SaaS电子合同',
          event_source_pam: 'SaaS电子合同',
          event_target: '亲笔签登录页',
          event_target_pam: null
        }]])])]),
        _: 1
      }), _createElementVNode("div", _hoisted_2, [_hoisted_3, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(specialty, ({
        description,
        ...item
      }, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "fixbox fadeInUp",
          key: index
        }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("object", {
          type: "image/svg+xml",
          data: item.imgSrc
        }, null, 8, _hoisted_5)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(item.ltitle), 1), (_openBlock(), _createBlock(_resolveDynamicComponent(description())))])]);
      }), 128))]), _createVNode(_unref(Scene), {
        source: "SaaS"
      }), _createVNode(_unref(GetForm), {
        class: "use-form",
        mainTitle: "立即体验电子签约全流程",
        desc: "为你的团队量身定制，多场景&多行业的解决方案"
      })], 64);
    };
  }
};